!(function($){
  
  var NS = {
    w: $(window),
    d: $(document),
    sidebar_toggle_filter: function(elem, all){
    	if ($(window).width() <= 767 || elem.parents('.sidebar').hasClass('toggle-all--true')) {
          if(elem.hasClass('open')){
            elem.removeClass('open');
            all.removeClass('open');
            elem.find('span').html('+');
          }else{
            all.removeClass('open');
           	all.find('span').html('+');
            elem.addClass('open');
            elem.find('span').html('-');
          }
        }
    },
    max_height_columns: function(){
      if($('.twelve.columns').length){
        
        var arr_heights = [],
            max = 0;
        
      	$('.twelve.columns').find('.products > .three.columns').each(function(i, el){
          
          var _that = $(this);
          
//        _that.removeAttr('style');
          _that.css('height','');
          
          arr_heights.push($(this).height());
          
          max = Math.max.apply(null, arr_heights);
          
        });
        
        arr_heights = [];
        
        function m_h(element, max_height){
          return element.height(max_height);
        }m_h($('.twelve.columns').find('.products > .three.columns'), max);  
        
      }
    },
    init: function(){
      this.max_height_columns();
    }
  }
  
  $(document).on('ready', function(){
    
    NS.init();
    
    
    
     $("#datepicker").datepicker({
      onSelect: function() {
        $(this).change();
        $('#f_p_test_3').show(200);
      }
   });
    
    $('.featured-promotions').find('.f_p_test').each(function(i, el){
      if(i != 0){
      	$(this).hide();
      }
    });
    
   
    // select 0
    
       $("#f_p_test_1").find('h3').hide(0);
    
       $('#f_p_test_0').find('> select').on('change', function() {
         
         var _that = $(this);
         
         if($(this).find('option:first:selected').length != 1){
		  $("#f_p_test_1").find('h3').hide(0);
          $('#f_p_test_1').show(200, function(){
          	$("#f_p_test_1").find('h3').each(function(index, elem){
              if($(this).attr('data-id') == _that.find('option:selected').attr('data-id')){
				$(this).show(0);
              }
          	});
          });
          
		  $('#f_p_test_2').hide(200);        
          
          }else{
            $('#f_p_test_1').hide(200);
            $('#f_p_test_2').hide(200);
            $('#f_p_test_3').hide(200);
          }
       	});
    
      // select 1
    
       $('#f_p_test_1').find('> select').on('change', function() {
         
        if($(this).find('option:first:selected').length != 1){
			
          $('#f_p_test_2').show(200);

        }else{
          $('#f_p_test_2').hide(200);
          $('#f_p_test_3').hide(200);
        }
       });    
    
    // click (.sidebar > div h4.toggle)
    
    $('.sidebar h4.toggle').on('click', function(){
      NS.sidebar_toggle_filter($(this), $('.sidebar h4.toggle'));
    });
    
    // touchstart (.sidebar > div h4.toggle)
    
    $('.sidebar h4.toggle').on('touchstart', function(e) {
      NS.sidebar_toggle_filter($(this), $('.sidebar h4.toggle')); 
      e.preventDefault();
      return false;
    });
    
    $(window).on('resize', function(){
    	NS.max_height_columns();
    });
    
  });
  
})(jQuery);